import type { AppState } from '../science/types';

export const createDefaultState = (): AppState => ({
  schemaVersion: '0.7',
  releaseLabel: 'research-release-candidate',
  era: 'modern',
  productMode: 'explore',
  accuracyMode: 'experiment-matched',
  manipulatorLevel: 'essential',
  analysisView: 'field',
  preset: '2019 Electro-Optic Vacuum Correlations',
  selectedProbe: 'A',
  scientific: {
    frequencyLog10: Math.log10(1.5e12),
    spatialLog10: -6,
    timeLog10: -12,
    temperature: 4,
    state: 'vacuum',
    fieldComponent: 'x',
    bandShape: 'gaussian',
    squeezingDb: 6,
    squeezingAngle: 45,
    detectorBandwidthLog10: Math.log10(1.8e12),
    detectorEfficiency: 0.85,
    integrationTimeLog10: -3,
    boundaryGeometry: 'none',
    boundarySeparationLog10: -6,
    cavityResonanceLog10: 9.93,
    boundaryModulation: false,
    modulationFrequencyLog10: 10,
    modulationAmplitude: 0.08,
    probeSeparation: 0,
    probeDelay: 0,
    numericalResolution: 48,
    randomSeed: 21092019,
    phaseVelocityFraction: 0.4,
    qualityFactor: 50,
    effectiveLengthLog10: Math.log10(0.44e-3),
    polarizabilityVolumeLog10: Math.log10(0.667e-30),
    atomicNumber: 1,
    cutoffRatio: 137
  },
  visualization: {
    gain: 4,
    fieldOntology: true,
    virtualParticleView: false,
    vectorsVisible: true,
    correlationsVisible: true,
    probesVisible: true,
    lightConesVisible: false,
    reducedMotion: typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false,
    animationPaused: false,
    animationSpeed: 1,
    sceneTool: 'orbit'
  }
});
